import { Injectable } from "@angular/core";
import { HSO_REGIONS } from "@shared/constants";

@Injectable({
  providedIn: "root",
})
export class LocationService {
  public get hostname(): string {
    return window.location.hostname;
  }

  public get region(): string {
    for (const [region, hsoRegion] of Object.entries(HSO_REGIONS)) {
      if (this.hostname.includes(`.${hsoRegion.toLowerCase()}.`)) {
        return region;
      }
    }

    return "eu-west-1";
  }
}
